<template>
  <v-card>
    <v-card-title>Что вы хотите добавить?</v-card-title>

    <v-card-text class="mt-10">
      <v-row>
        <v-col align="center">
          <v-btn depressed color="primary" title="Добавить документ" @click="addDocument">
            <v-icon left>add</v-icon>
            Документ
          </v-btn>
        </v-col>
        <v-col align="center">
          <v-btn depressed color="primary" title="Записать на приём" @click="addAppointment">
            <v-icon left>add</v-icon>
            Запись
          </v-btn>
        </v-col>

        <v-col align="center">
          <v-btn depressed color="primary" title="Добавить документ" @click="addMedicine">
            <v-icon left>add</v-icon>
            Лекарство
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions></v-card-actions>
  </v-card>
</template>

<script>
import Modal from "@/components/Modal";
import AddDocument from "@/modules/documents/add-document/AddDocument.vue";
import AddMedicine from "@/components/modals/AddMedicine.vue";
import Schedule from "@/modules/schedule/Schedule.vue";
import { formModal } from "@/mixins/modal/form-modal";
import { Doctor } from "@/modules/doctors/Doctor.js";
import { mapState } from "vuex";

export default {
  name: "SelectModalType",
  components: { Modal, AddDocument },
  mixins: [formModal],

  props: {
    date: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapState("auth", ["profile"]),
  },
  methods: {
    addDocument() {
      this.$dialog.showAndWait(AddDocument, { width: "600px", persistent: true, date: this.date });
    },
    addMedicine() {
      this.$dialog.show(AddMedicine, { width: "600px", persistent: true, date: this.date });
    },
    addAppointment() {
      const doctor = new Doctor({
        id: this.profile.id,
        firstName: this.profile.name,
        lastName: this.profile.surname,
        middleName: this.profile.patronymic,
      });
      this.$dialog.show(Schedule, { width: "600px", date: this.date, doctor: doctor, allowSelectOtherDoctors: true });
    },
  },
};
</script>

<style scoped></style>
